<div>
  @if(data.selectorContainer) {
    <div>
      <app-search-view-selector
        [selectorContainer]="data.selectorContainer"
        (modalClosed)="dialogRef.close([])"
      />
    </div>
  }
  @else {
    <p>
      no selector
    </p>
  }
</div>
